module.exports = __webpack_public_path__ + "static/media/resident_avatar_male.2ce20753.png";